import { LegalLayout } from "@/components/LegalLayout";
import { PRIVACY } from "@/content/privacy";

export default function PrivacyPolicy() {
  return <LegalLayout doc={PRIVACY} testId="privacy-page" />;
}
